import { db } from 'src/config/firebase';

const getSchedule = async (serviceId) => {

  try {
    const snapshot = await db
      .ref('Schedules')
      .orderByChild('serviceId')
      .equalTo(serviceId)
      .once('value');
    const data = await snapshot.val();

    let _data = null;
    if(data && Object.keys(data)?.length) {
        _data = Object.values(data)?.[0];
    }
    return _data || null;
  } catch (error) {
    console.warn('Error fetching schedule: ', error.message);
  }
};

export default getSchedule;